import {WS_ON_MESSAGE, WS_ON_MESSAGE_EVENT_CONFIRMED} from '../Types/Websocket';


export const wsOnMessageAction = (msg) => {
    console.log("WebsocketActions wsOnMessageAction");
    return {
        type: WS_ON_MESSAGE,
        payload: msg
    }
};
export const wsOnMessageEventConfirmed = (msg) => {
    console.log("WebsocketActions wsOnMessageConfirmed");
    return {
        type: WS_ON_MESSAGE_EVENT_CONFIRMED,
        payload: msg
    }
};




// WEBPACK FOOTER //
// ./src/Actions/WebsocketActions.js